var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, indent, no-var, object-curly-spacing, one-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp, space-infix-ops */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var lens = require("../../hubble/index.js");

var Changeable = require("../mixins/changeable.jsx");

var InfoTip = require("../components/info-tip.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var SortableArea = require("react-components/sortable.jsx");
var TeX = require("react-components/tex.jsx"); // OldExpression only
var TexButtons = require("../components/tex-buttons.jsx");

var Expression = require("./expression.jsx").Expression;

// An answer can be considered correct, wrong, or ungraded.
var CONSIDERED = ["correct", "wrong", "ungraded"];

var answerFormType = React.PropTypes.shape({
    considered: React.PropTypes.oneOf(CONSIDERED).isRequired,
    value: React.PropTypes.string.isRequired,
    form: React.PropTypes.bool.isRequired,
    simplify: React.PropTypes.bool.isRequired
});

// Pick a key that isn't currently used by an answer in answerForms
var _makeNewKey = function _makeNewKey(answerForms) {
    // first note all the currently used keys in an array, used like a map :3
    // note that this automatically updates the array's length property to
    // be one past the largest key.
    var usedKeys = [];
    answerForms.forEach(function (ans) {
        usedKeys[ans.key] = true;
    });

    // then scan through the array to find the first unused (undefined) key
    for (var i = 0; i < usedKeys.length; i++) {
        if (!usedKeys[i]) {
            return i;
        }
    }

    // if we didn't find a key, make one bigger than all the other keys,
    // since that's how the length property is defined to work on arrays
    return usedKeys.length;
};

var ExpressionEditor = React.createClass({
    displayName: "ExpressionEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        answerForms: React.PropTypes.arrayOf(answerFormType),
        times: React.PropTypes.bool,
        buttonSets: TexButtons.buttonSetsType,
        functions: React.PropTypes.arrayOf(React.PropTypes.string)
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            answerForms: [],
            times: false,
            buttonSets: ["basic"],
            functions: ["f", "g", "h"]
        };
    },

    getInitialState: function getInitialState() {
        // Is the format of `value` TeX or plain text?
        // TODO(alex): Remove after backfilling everything to TeX
        // TODO(joel) - sucks if you edit some expression without
        // backslashes or curly braces, then come back to the question and
        // it's surprisingly not TeX anymore.

        var isTex;
        // default to TeX if new;
        if (this.props.answerForms.length === 0) {
            isTex = true;
        } else {
            isTex = _(this.props.answerForms).any(function (form) {
                var value = form.value;
                // only TeX has backslashes and curly braces

                return _.indexOf(value, "\\") !== -1 || _.indexOf(value, "{") !== -1;
            });
        }

        return { isTex: isTex };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var _this = this;

        var answerOptions = this.props.answerForms.map(function (obj, ix) {
            var expressionProps = {
                // note we're using
                // *this.props*.{times,functions,buttonSets} since each
                // answer area has the same settings for those
                times: _this.props.times,
                functions: _this.props.functions,
                buttonSets: _this.props.buttonSets,

                buttonsVisible: "focused",
                form: obj.form,
                simplify: obj.simplify,
                value: obj.value,

                onChange: function onChange(props) {
                    return _this.updateForm(ix, props);
                },
                trackInteraction: function trackInteraction() {},

                widgetId: _this.props.widgetId + "-" + ix
            };

            return lens(obj).merge([], {
                draggable: true,
                onChange: function onChange(props) {
                    return _this.updateForm(ix, props);
                },
                onDelete: function onDelete() {
                    return _this.handleRemoveForm(ix);
                },
                expressionProps: expressionProps
            }).freeze();
        }).map(function (obj) {
            return React.createElement(AnswerOption, obj);
        });

        var sortable = React.createElement(SortableArea, {
            components: answerOptions,
            onReorder: this.handleReorder,
            className: "answer-options-list"
        });

        // checkboxes to choose which sets of input buttons are shown
        var buttonSetChoices = _(TexButtons.buttonSets).map(function (set, name) {
            // The first one gets special cased to always be checked, disabled,
            // and float left.
            var isFirst = name === "basic";
            var checked = _.contains(_this.props.buttonSets, name) || isFirst;
            var className = isFirst ? "button-set-label-float" : "button-set-label";
            return React.createElement(
                "label",
                { className: className, key: name },
                React.createElement("input", {
                    type: "checkbox",
                    checked: checked,
                    disabled: isFirst,
                    onChange: function onChange() {
                        return _this.handleButtonSet(name);
                    }
                }),
                name
            );
        });

        buttonSetChoices.splice(1, 1, React.createElement(
            "label",
            { key: "show-div" },
            React.createElement("input", { type: "checkbox", onChange: this.handleToggleDiv }),
            React.createElement(
                "span",
                { className: "show-div-button" },
                "show ",
                React.createElement(
                    TeX,
                    null,
                    "\\div"
                ),
                " button"
            )
        ));

        return React.createElement(
            "div",
            { className: "perseus-widget-expression-editor" },
            React.createElement(
                "h3",
                { className: "expression-editor-h3" },
                "Global Options"
            ),
            React.createElement(
                "div",
                null,
                React.createElement(PropCheckBox, {
                    times: this.props.times,
                    onChange: this.props.onChange,
                    labelAlignment: "right",
                    label: "Use \xD7 for rendering multiplication instead of a center dot."
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "For pre-algebra problems this option displays multiplication as \\times instead of \\cdot in both the rendered output and the acceptable formats examples."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Function variables: ",
                    React.createElement("input", {
                        type: "text",
                        defaultValue: this.props.functions.join(" "),
                        onChange: this.handleFunctions
                    })
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Single-letter variables listed here will be interpreted as functions. This let us know that f(x) means \"f of x\" and not \"f times x\"."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "div",
                    null,
                    "Button sets:"
                ),
                buttonSetChoices
            ),
            this.state.isTex && React.createElement(TexButtons, {
                className: "math-input-buttons",
                sets: this.props.buttonSets,
                convertDotToTimes: this.props.times,
                onInsert: this.handleTexInsert
            }),
            React.createElement(
                "h3",
                { className: "expression-editor-h3" },
                "Answers"
            ),
            React.createElement(
                "p",
                { style: { margin: "4px 0" } },
                "student responses area matched against these from top to bottom"
            ),
            sortable,
            React.createElement(
                "div",
                null,
                React.createElement(
                    "button",
                    {
                        className: "simple-button orange",
                        style: { fontSize: 13 },
                        onClick: this.newAnswer,
                        type: "button"
                    },
                    "Add new answer"
                )
            )
        );
    },

    serialize: function serialize() {
        var formSerializables = ["value", "form", "simplify", "considered",
        // it's a little weird to serialize the react key, but saves some
        // effort reconstructing them when this item is loaded later.
        "key"];
        var serializables = ["answerForms", "buttonSets", "functions", "times"];

        var answerForms = this.props.answerForms.map(function (form) {
            return _(form).pick(formSerializables);
        });

        return lens(this.props).set(["answerForms"], answerForms).mod([], function (props) {
            return _(props).pick(serializables);
        }).freeze();
    },

    getSaveWarnings: function getSaveWarnings() {
        var _this2 = this;

        var issues = [];

        if (this.props.answerForms.length === 0) {
            issues.push("No answers specified");
        } else {
            var hasCorrect = !!_(this.props.answerForms).find(function (form) {
                return form.considered === "correct";
            });
            if (!hasCorrect) {
                issues.push("No correct answer specified");
            }

            _(this.props.answerForms).each(function (form, ix) {
                if (_this2.props.value === "") {
                    issues.push("Answer " + (ix + 1) + " is empty");
                } else {
                    // note we're not using icu for content creators
                    var expression = KAS.parse(form.value);
                    if (!expression.parsed) {
                        issues.push("Couldn't parse " + form.value);
                    } else if (form.simplify && !expression.expr.isSimplified()) {
                        issues.push(form.value + " isn't simplified, but is required\" +\n                            \" to be");
                    }
                }
            });

            // TODO(joel) - warn about:
            //   - unreachable answers (how??)
            //   - specific answers following unspecific answers
            //   - incorrect answers as the final form
        }

        return issues;
    },

    _newEmptyAnswerForm: function _newEmptyAnswerForm() {
        return {
            considered: "correct",
            form: false,

            // note: the key means "n-th form created" - not "form in
            // position n" and will stay the same for the life of this form
            key: _makeNewKey(this.props.answerForms),

            simplify: false,
            value: ""
        };
    },

    newAnswer: function newAnswer() {
        var answerForms = this.props.answerForms.slice();
        answerForms.push(this._newEmptyAnswerForm());
        this.change({ answerForms: answerForms });
    },

    handleRemoveForm: function handleRemoveForm(i) {
        var answerForms = this.props.answerForms.slice();
        answerForms.splice(i, 1);
        this.change({ answerForms: answerForms });
    },

    // called when the options (including the expression itself) to an answer
    // form change
    updateForm: function updateForm(i, props) {
        var answerForms = lens(this.props.answerForms).merge([i], props).freeze();

        this.change({ answerForms: answerForms });
    },

    handleReorder: function handleReorder(components) {
        var answerForms = _(components).map(function (component) {
            var form = _(component.props).pick("considered", "form", "simplify", "value");
            form.key = component.key;
            return form;
        });

        this.change({ answerForms: answerForms });
    },

    // called when the selected buttonset changes
    handleButtonSet: function handleButtonSet(changingName) {
        var _this3 = this;

        var buttonSetNames = _(TexButtons.buttonSets).keys();

        // Filter to preserve order - using .union and .difference would always
        // move the last added button set to the end.
        var buttonSets = _(buttonSetNames).filter(function (set) {
            return _(_this3.props.buttonSets).contains(set) !== (set === changingName);
        });

        this.props.onChange({ buttonSets: buttonSets });
    },

    handleToggleDiv: function handleToggleDiv() {
        // We always want buttonSets to contain exactly one of "basic" and
        // "basic+div". Toggle between the two of them.
        // If someone can think of a more elegant formulation of this (there
        // must be one!) feel free to change it.
        var keep, remove;
        if (_(this.props.buttonSets).contains("basic+div")) {
            keep = "basic";
            remove = "basic+div";
        } else {
            keep = "basic+div";
            remove = "basic";
        }

        var buttonSets = _(this.props.buttonSets).reject(function (set) {
            return set === remove;
        }).concat(keep);

        this.change("buttonSets", buttonSets);
    },

    // called when the correct answer changes
    handleTexInsert: function handleTexInsert(str) {
        this.refs.expression.insert(str);
    },

    // called when the function variables change
    handleFunctions: function handleFunctions(e) {
        var newProps = {};
        newProps.functions = _.compact(e.target.value.split(/[ ,]+/));
        this.props.onChange(newProps);
    }
});

// Find the next element in arr after val, wrapping around to the first.
var findNextIn = function findNextIn(arr, val) {
    var ix = _(arr).indexOf(val);
    ix = (ix + 1) % arr.length;
    return arr[ix];
};

var AnswerOption = React.createClass({
    displayName: "AnswerOption",

    propTypes: _extends({}, Changeable.propTypes, {
        considered: React.PropTypes.oneOf(CONSIDERED).isRequired,
        expressionProps: React.PropTypes.object.isRequired,

        // Must the answer have the same form as this answer.
        form: React.PropTypes.bool.isRequired,

        // Must the answer be simplified.
        simplify: React.PropTypes.bool.isRequired,

        onChange: React.PropTypes.func.isRequired,
        onDelete: React.PropTypes.func.isRequired
    }),

    getInitialState: function getInitialState() {
        return { deleteFocused: false };
    },

    handleDeleteBlur: function handleDeleteBlur() {
        this.setState({ deleteFocused: false });
    },

    change: function change() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var removeButton = null;
        if (this.state.deleteFocused) {
            removeButton = React.createElement(
                "button",
                {
                    type: "button",
                    className: "simple-button orange",
                    onClick: this.handleImSure,
                    onBlur: this.handleDeleteBlur
                },
                "I'm sure!"
            );
        } else {
            removeButton = React.createElement(
                "button",
                {
                    type: "button",
                    className: "simple-button orange",
                    onClick: this.handleDelete
                },
                "Delete"
            );
        }

        return React.createElement(
            "div",
            { className: "expression-answer-option" },
            React.createElement("div", { className: "answer-handle" }),
            React.createElement(
                "div",
                { className: "answer-body" },
                React.createElement(
                    "div",
                    { className: "answer-considered" },
                    React.createElement(
                        "div",
                        {
                            onClick: this.toggleConsidered,
                            className: "answer-status " + this.props.considered
                        },
                        this.props.considered
                    ),
                    React.createElement(
                        "div",
                        { className: "answer-expression" },
                        React.createElement(Expression, this.props.expressionProps)
                    )
                ),
                React.createElement(
                    "div",
                    { className: "answer-option" },
                    React.createElement(PropCheckBox, {
                        form: this.props.form,
                        onChange: this.props.onChange,
                        labelAlignment: "right",
                        label: "Answer expression must have the same form."
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "The student's answer must be in the same form. Commutativity and excess negative signs are ignored."
                        )
                    )
                ),
                React.createElement(
                    "div",
                    { className: "answer-option" },
                    React.createElement(PropCheckBox, {
                        simplify: this.props.simplify,
                        onChange: this.props.onChange,
                        labelAlignment: "right",
                        label: "Answer expression must be fully expanded and simplified."
                    }),
                    React.createElement(
                        InfoTip,
                        null,
                        React.createElement(
                            "p",
                            null,
                            "The student's answer must be fully expanded and simplified. Answering this equation (x^2+2x+1) with this factored equation (x+1)^2 will render this response \"Your answer is not fully expanded and simplified.\""
                        )
                    )
                ),
                React.createElement(
                    "div",
                    { className: "remove-container" },
                    removeButton
                )
            )
        );
    },

    handleImSure: function handleImSure() {
        this.props.onDelete();
    },

    handleDelete: function handleDelete() {
        this.setState({ deleteFocused: true });
    },

    toggleConsidered: function toggleConsidered() {
        var newVal = findNextIn(CONSIDERED, this.props.considered);
        this.change({ considered: newVal });
    }
});

module.exports = ExpressionEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/expression-editor.jsx
 ** module id = 74
 ** module chunks = 0 2
 **/